import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { IListDto } from "../../../interface/dto/list.dto";
import { get } from "../../../service/api";

export const getHistory = (tokens: ITokenPair): Observable<Array<IListDto>> =>
    get<Array<IListDto>>("/lists/hit-history", undefined, tokens);
